import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { RegistrationsViewModel } from "../../features/registrations/registrations-viewmodel";
import { getTimeFromTimestamp } from "../../utils/formatters";
import { useViewModel } from "../../viewmodel/use-view-model";
export const RegistrationHistoryView = observer(() => {
    const vm = useViewModel(RegistrationsViewModel);
    const { t } = useTranslation();
    // groupHistoryByDay does an expensive reduce+sort; recompute it only
    // when the underlying history changes rather than on every render.
    const history = vm.history;
    const _groupedHistory = useMemo(() => vm.groupHistoryByDay(history), [vm, history]);
    if (_groupedHistory === null) {
        return _jsx(_Fragment, {});
    }
    const tHeaders = {
        time: t("registrations.history.time"),
        status: t("registrations.history.status"),
        name: t("registrations.history.name"),
        reason: t("registrations.history.reason"),
        externalUserId: t("registrations.history.externalUserId"),
        version: t("registrations.history.version"),
    };
    return (_jsxs(_Fragment, { children: [_jsx("h5", { className: "ms-3", children: t("registrations.history.title") }), _jsx("div", { className: "accordion", id: "accordionHistory", children: Object.entries(_groupedHistory).map(([day, history], index) => renderHistoryDay(day, history, tHeaders, index === 0, t)) })] }));
});
function renderHistoryDay(day, history, headers, isFirst, t) {
    const elementId = `acc-${safeQueryParam(day)}`;
    const showClass = isFirst ? "show" : "";
    const expanded = isFirst ? "true" : "false";
    const buttonClass = isFirst ? "accordion-button" : "accordion-button collapsed";
    return (_jsxs("div", { className: "accordion-item", children: [_jsx("div", { className: "accordion-header", children: _jsx("button", { type: "button", className: buttonClass, "data-bs-toggle": "collapse", "data-bs-target": `#${elementId}`, "aria-expanded": expanded, "aria-controls": `#${elementId}`, children: formattedDate(day) }) }), _jsx("div", { id: elementId, className: `accordion-collapse collapse ${showClass}`, "data-bs-parent": "#accordionHistory", children: _jsx("div", { className: "accordion-body", children: _jsxs("table", { className: "table table-hover table-borderless", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: headers.time }), _jsx("th", { children: headers.status }), _jsx("th", { children: headers.name }), _jsx("th", { children: headers.reason }), _jsx("th", { children: headers.externalUserId }), _jsx("th", { children: headers.version })] }) }), _jsx("tbody", { children: history.map((entry) => renderHistoryEntry(entry, t)) })] }) }) })] }, day));
}
function renderHistoryEntry(history, t) {
    return (_jsxs("tr", { className: "align-middle", children: [_jsx("td", { children: getTimeFromTimestamp(history.timestamp) }), _jsx("td", { children: t(`registrations.status.${history.status}`) }), _jsx("td", { children: history.name }), _jsx("td", { children: history.reason }), _jsx("td", { children: history.externalUserId }), _jsx("td", { children: history.version })] }, safeQueryParam(history.timestamp ?? '')));
}
function safeQueryParam(query) {
    return query.replace(/[^a-zA-Z0-9]/g, '');
}
function formattedDate(dateStr) {
    const date = new Date(dateStr);
    const month = date.toLocaleString('default', { month: 'long' });
    return `${date.getDate()} ${month} ${date.getFullYear()}`;
}
